import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteHostelRoom = async (ID) => {
  try {
    const HostelDocument = doc(db, "Hostel", ID);

    await updateDoc(HostelDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteHostelRoom;
